// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.canvas[data-v-7de2a7d2] {\r\n\tborder-radius: 5px;\r\n\theight: 600px; margin: 0 20px 20px 20px;\r\n\twidth: auto !important;\n}\n[data-v-7de2a7d2] .canvas > canvas { border-color: var(--main-gray-2);border-radius: 5px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
